export const CLoanDurationSelectorDurations: Array<number> = [5, 10, 15, 20, 25];